import Image from 'next/image'
import open from '../../../public/images/nav/mobile/hamburger.png'
import close from '../../../public/images/nav/mobile/close-black.png'

const Hamburger = ({ type = 'open' }) => {
    const width = 40
    const height = 40 
    const attributes = { 
        width, 
        height, 
        src: type === 'open' ? open : close, 
        alt: 'jts-hambuger', 
        placeholder: 'blur',
        loading: 'eager'
    } 
    return <>
        <Image {...attributes}/>
    </>
}

export default Hamburger